import _extends from "@babel/runtime/helpers/esm/extends";
import { jsx as _jsx } from "react/jsx-runtime";
import { Components as HintComponents } from './hint.style';
const Hint = _ref => {
  let {
    hint,
    hintPosition = 'left'
  } = _ref;
  return _jsx(HintComponents.HintText, _extends({
    hintPosition: hintPosition
  }, {
    children: hint
  }));
};
export default Hint;